import { BaseAction } from './base.action';
import { InvitationService, NotificationService } from '../../services';
import { SkillAvailableCondition } from '../conditions';
import { ICondition } from '../../interfaces';

export class ShowProactiveChatAction extends BaseAction {
    isChatOpened: boolean;
    skillAvailableCondition: ICondition;

    constructor(
        private invitationService: InvitationService,
        private notificationService: NotificationService
    ) {
        super();

        // Subscribe to chat state notifications.
        this.notificationService.chatState$.subscribe(isChatOpen => {
            this.isChatOpened = isChatOpen;
        });
    }

    addCondition(condition: ICondition): void {
        // Skill availability must be checked only after all other conditions are fulfilled.
        if (condition instanceof SkillAvailableCondition) {
            this.skillAvailableCondition = condition;
        } else {
            super.addCondition(condition);
        }
    }

    act(): void {
        if (this.isChatOpened) {
            console.log('Chat invitation was not shown, chat already open.');
        }
        else {
            // All conditions are met, check if the required skill available before showing an invitation.
            if (this.skillAvailableCondition) {
                console.log('Checking skill availability before showing a chat invitation...');
                this.skillAvailableCondition.observable.subscribe(result => {
                    if (result)
                        this.showInvitation();
                    else
                        console.log('Chat invitation was not shown, no agent with the required skill available.');
                });
            }
            else
                this.showInvitation();
        }
    }

    showInvitation(): void {
        this.invitationService.showInvitation();
        // Invoke auto-close action if we have any.
        if (this.nextAction) {
            this.nextAction.invoke();
        }
    }
}
